// removed by extract-text-webpack-plugin
module.exports = {"tabs":"_2SejuTcIlka7Qaozg3oP8f","tab":"Uk8j8j3GtU9RgcpLy_UOL","title":"_3anXAqWeBSYucWbUYlAUd1","switch":"_1PCajxVFlmigq4gWsLGrsd","active":"_369kFTOFZD27rYS40GkdUP","addTab":"Ziot5KbDOiQoqP2tb-Alm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendBoxTabs.scss
// module id = 1301
// module chunks = 1